export default __webpack_public_path__ + "static/media/products-5.d27deea2.webp";